import { Suspense, lazy } from "react";

import { clerkEnabled } from "@/lib/clerk";

// Lazy on purpose — see ClerkRuntime for why. With no key configured this
// import is never evaluated, so the SDK is neither bundled nor resolved.
const ClerkRuntime = lazy(() => import("./ClerkRuntime"));

/**
 * Mounts Clerk, but only when it is configured.
 *
 * With no publishable key this renders its children untouched and the app runs
 * on the legacy auth path. That mirrors the backend, where AUTH_PROVIDER
 * defaults to "legacy": a half-configured deployment should behave like the
 * old one, not like a broken new one.
 */
export default function ClerkGate({ children }) {
  if (!clerkEnabled()) return children;
  return (
    <Suspense fallback={null}>
      <ClerkRuntime>{children}</ClerkRuntime>
    </Suspense>
  );
}
